import z from "zod";

import { Certificate, CERTIFICATE_LABELS } from "@/enums/certificates";
import { closedEnum } from "@/schemas/closed-enum";

export const CertificateSchema = z.object({
  value: closedEnum(Certificate, CERTIFICATE_LABELS),
  customName: z.string().nullable(),
});

export const CertificateCreateSchema = CertificateSchema.extend({
  customName: z.string().nullish(),
});
